import { render, staticRenderFns } from "./DocumentsEkp.vue?vue&type=template&id=3618efc0"
import script from "./DocumentsEkp.vue?vue&type=script&lang=js"
export * from "./DocumentsEkp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports